export const pageList = [
  {
    pageKey: "main",
    pageName: "首页",
  },
  {
    pageKey: "memberList",
    pageName: "会员列表",
  },
  {
    pageKey: "deviceType",
    pageName: "设备型号",
  },
  {
    pageKey: "deviceList",
    pageName: "设备管理",
  },
  {
    pageKey: "positionScene",
    pageName: "场景管理",
  },
  {
    pageKey: "positionRegion",
    pageName: "运营区域",
  },
  {
    pageKey: "positionList",
    pageName: "点位管理",
  },
  {
    pageKey: "warehouseList",
    pageName: "仓库列表",
  },
  {
    pageKey: "warehouseMoveList",
    pageName: "移动库列表",
  },
  {
    pageKey: "warehouseMoveUpper",
    pageName: "移动库入库",
  },
  {
    pageKey: "warehouseMoveLower",
    pageName: "移动库出库",
  },
  {
    pageKey: "warehouseLowerUpper",
    pageName: "出入库列表",
  },
  {
    pageKey: "warehouseLoss",
    pageName: "报损列表",
  },
  {
    pageKey: "supplier",
    pageName: "供应商管理",
  },
  {
    pageKey: "personList",
    pageName: "人员管理",
  },
  {
    pageKey: "personDepartment",
    pageName: "部门管理",
  },
  {
    pageKey: "personRole",
    pageName: "人员角色",
  },
  {
    pageKey: "company",
    pageName: "分公司管理",
  },
  {
    pageKey: "systemLogOperate",
    pageName: "操作日志",
  },
  {
    pageKey: "systemLogLogin",
    pageName: "登录日志",
  },
  {
    pageKey: "reportUser",
    pageName: "用户报表",
  },
  {
    pageKey: "reportDevice",
    pageName: "设备报表",
  },
  {
    pageKey: "reportOperate",
    pageName: "运营趋势",
  },
  {
    pageKey: "deviceStock",
    pageName: "设备库存",
  },
  {
    pageKey: "operateData",
    pageName: "经营数据",
  },
  {
    pageKey: "reportBaseInfo",
    pageName: "基础信息查询",
  },
  {
    pageKey: "exportCenterList",
    pageName: "导出列表",
  },
  {
    pageKey: "taskList",
    pageName: "任务列表",
  }
];